 
<!--
 * @Author: 仙道
 * @Date: 2022-06-21 16:12:52
 * @LastEditTime: 2022-09-18 19:57:38
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/overhaul.vue
-->
 
<template>
  <grid-table :columns="columns" :queryParams="queryParams" :url="url" ref="table">
    <span slot="internalExecutor" slot-scope="text,record">{{record.internalExecutor_dictText}}</span>
    <span slot="statusSlot" slot-scope="taskStatus">
      <span v-if="taskStatus== '-1'">
        <a-tag color="#108ee9">编辑中</a-tag>
      </span>
      <span v-else-if="taskStatus== '0'">
        <a-tag color="#faad14">已发布</a-tag>
      </span>
      <span v-else>
        <a-tag color="#52c41a">已完成</a-tag>
      </span>
    </span>
  </grid-table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridTable from "./Itable";

  export default {
    // 检修
    name: 'Overhaul',
    components: {
      GridTable,
    },

    // 定义属性
    data () {
      return {
        url: '/maintenance/overhaul/list',
        queryParams: {
          taskStatus: 0
        },
        columns: [
          {
            title: '任务日期',
            align: "center",
            dataIndex: 'taskDate',
            customRender: function (text) {
              return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
            },

          },
          {
            title: '负责人',
            align: "center",
            dataIndex: 'manager_dictText',
            scopedSlots: { customRender: 'manager_dictText' },

          },
          {
            title: '外聘执行人员',
            align: "center",
            dataIndex: 'internalExecutor_dictText'
          },
          {
            title: '任务状态',
            align: "center",
            dataIndex: 'taskStatus',
            scopedSlots: { customRender: 'statusSlot' },

          },
          {
            title: '完成时间',
            align: "center",
            dataIndex: 'finishTime'
          },
        ]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      queryData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>
 